import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectWorkTypeValue } from '../../services/workTypes/selectors';

interface Props {
    isPieceRate?: ?boolean;
    truthyValue?: string;
    falsyValue?: string;
}

export class WorkTypeIsPieceRate extends React.PureComponent<Props> {
    static defaultProps = {
        truthyValue: 'true',
        falsyValue: 'false'
    };

    render() {
        const { isPieceRate, truthyValue, falsyValue } = this.props;
        return isPieceRate ? truthyValue : falsyValue;
    }
}

const mapStateToProps = createStructuredSelector({
    isPieceRate: makeSelectWorkTypeValue('isPieceRate')
});

export default connect(mapStateToProps)(WorkTypeIsPieceRate);
